import { X } from 'lucide-react'
import { useTranslation } from '@/i18n'

interface Props {
  onClose: () => void
}

/**
 * The "Close · Esc" control every tag-mapping preview puts top-right.
 *
 * ONE component, because two copies had already drifted from the frame in the
 * same way: the mapped-tag overlay and the file preview both shipped it as a
 * PRIMARY (dark) fill with a translucent white key chip. Figma 13 draws it on
 * a white Hover Card as a white button with dark text, the Esc key a muted
 * chip — Pratima's screenshot of 2026-09-24 11:40 against the app. The card
 * around it and the button inside it are both `background`-coloured on
 * purpose: the frame's affordance is the card, not a filled button.
 */
export default function PreviewCloseButton({ onClose }: Props) {
  const { t } = useTranslation()
  return (
    <div
      className="absolute right-3.5 top-3.5 z-20 flex items-center rounded-[8px] border border-border bg-popover p-1.5 shadow-xs"
      onClick={(e) => e.stopPropagation()}
    >
      <button
        type="button"
        data-testid="preview-close"
        className="flex h-8 items-center gap-1.5 rounded-[8px] bg-background px-2.5 py-2 text-sm font-medium text-foreground transition-colors hover:bg-muted"
        onClick={(e) => {
          e.stopPropagation()
          onClose()
        }}
      >
        <X className="size-4" />
        {t('data_catalog:tag_mapping.preview.close', { defaultValue: 'Close' })}
        <kbd className="flex h-5 min-w-5 items-center justify-center rounded-[6px] bg-muted px-1 text-xs font-medium text-muted-foreground">
          Esc
        </kbd>
      </button>
    </div>
  )
}
